import {
    Component,
    Directive,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { NgbDropdown } from '@cmps/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';

import { AuthUser } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import { NotificationPanelService } from '../notification/notification-panel.service';
import { UserService } from '../user/user.service';

import { TranslationKeyMap } from './nav.i18n';
import { KeyboardNavigator } from './nav.keyboard';
import { NavItem, NavLoader } from './nav.model';
import { NavService } from './nav.service';

@Directive({
    selector: '[cmpsDropdownCard]',
})
export class DropdownCardDirective implements OnInit, OnDestroy {
    @Input('cmpsDropdownCard')
    private _dropdown: NgbDropdown;

    private _sub: Subscription;

    constructor(private readonly _el: ElementRef) {}

    ngOnInit(): void {
        this._sub = this._dropdown.openChange.subscribe(this._onOpenChange);
    }

    ngOnDestroy(): void {
        jQuery(window).off('resize', this._onResize);
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }

    private readonly _onResize = (): void => {
        jQuery(window).off('resize', this._onResize);
        this._dropdown.close();
    };

    private readonly _onOpenChange = (open: boolean): void => {
        console.log(open);

        const el = this._el.nativeElement;
        const el2 = el.querySelector('.cmps-dropdown-deck');

        if (!open) {
            this._dropdown.placement = 'bottom-left';
            el.classList.remove('show-dropdown-deck');
            if (el2) {
                ['full-width', 'full-height'].forEach((value) =>
                    el2.classList.remove(value),
                );
                el2.style.transform = 'none';
                el2.style.maxHeight = 'none';
            }
            document.body.classList.remove('cmps-navbar-fixed-overflow');
            return;
        }

        if (!el2) return;

        const width = jQuery(el2).outerWidth();
        const posStart = jQuery(el).offset().left;
        const posEnd = posStart + width;
        const windowPadding = window.innerWidth * 0.01;
        const paddedWindowWidth = window.innerWidth - windowPadding * 2;
        const toggleHeight = jQuery(el).outerHeight();

        console.log(
            posStart,
            posEnd,
            width,
            window.innerWidth,
            paddedWindowWidth,
            toggleHeight,
            jQuery(el2).outerHeight(),
        );

        el.classList.add('show-dropdown-deck');
        if (posEnd <= paddedWindowWidth) return;

        const toggleWidth = jQuery(el).outerWidth();
        const posCenter = posStart + toggleWidth / 2;
        const halfWidth = width / 2;

        console.log(
            posStart - width / 2,
            windowPadding,
            posEnd - width / 2,
            paddedWindowWidth,
        );
        console.log(
            posCenter - halfWidth,
            windowPadding,
            posCenter + halfWidth,
            paddedWindowWidth,
        );

        if (width < posStart) {
            this._dropdown.placement = 'bottom-right';
        } else if (
            posCenter - halfWidth > windowPadding &&
            posCenter + halfWidth < paddedWindowWidth
        ) {
            el2.style.transform = `translateX(${
                -50 + ((100 / width) * toggleWidth) / 2
            }%)`;
        } else {
            el2.classList.add('full-width');
            console.log(toggleHeight, jQuery(el2).outerHeight());
            if (
                toggleHeight + jQuery(el2).outerHeight() >=
                window.innerHeight
            ) {
                el2.classList.add('full-height');
                el2.style.maxHeight = `${window.innerHeight - toggleHeight}px`;
                document.body.classList.add('cmps-navbar-fixed-overflow');
            }
        }

        jQuery(window).on('resize', this._onResize);
    };
}

@Component({
    selector: 'cmps-nav',
    templateUrl: './nav.component.html',
    host: {
        '(keydown)': '_keyboardNavigator.handleEvent($event)',
        '(keyup)': '_keyboardNavigator.handleEvent($event)',
    },
})
export class NavComponent implements OnInit, OnDestroy, NavLoader {
    @ViewChildren(NgbDropdown)
    private readonly _ngbDropdowns: QueryList<NgbDropdown>;

    i18n = TranslationKeyMap;
    private _isCollapsed: boolean;
    private _routerEventsSub: Subscription;
    nav: NavItem[];
    navLoaded: boolean;
    navError: boolean;
    private readonly _panelToggleSub: Subscription;
    private readonly _notificationSub: Subscription;
    newNotificationCount: number;
    photoUrl: SafeResourceUrl;
    logoutUrl: string;
    private readonly _keyboardNavigator: KeyboardNavigator;

    get isCollapsed(): boolean {
        return this._isCollapsed;
    }

    set isCollapsed(value: boolean) {
        this._isCollapsed = value;
        // TODO add/remove class on window resize
        const className = 'cmps-navbar-fixed-overflow';
        if (!this._isCollapsed) {
            document.body.classList.add(className);
        } else {
            document.body.classList.remove(className);
        }
    }

    get isNotificationPanelOpen(): boolean {
        return this._notificationPanelService.isOpen;
    }

    get user(): AuthUser {
        return this._authService.user;
    }

    get hasPhotoUrl(): boolean {
        return !!this.photoUrl;
    }

    constructor(
        private readonly _el: ElementRef,
        private readonly _router: Router,
        private readonly _domSanitizer: DomSanitizer,
        private readonly _navService: NavService,
        private readonly _userService: UserService,
        private readonly _notificationPanelService: NotificationPanelService,
        private readonly _authService: AuthService,
    ) {
        this.isCollapsed = true;
        _navService.register(this);

        this._panelToggleSub = this._notificationPanelService.toggle.subscribe(
            (isOpen) => {
                if (isOpen) {
                    this.newNotificationCount = 0;
                }
            },
        );
        this._notificationSub =
            this._notificationPanelService.notificationChange.subscribe(() => {
                if (!this._notificationPanelService.isOpen) {
                    this.newNotificationCount =
                        this._notificationPanelService.unAcknowledged.length;
                }
            });

        this._keyboardNavigator = new KeyboardNavigator(_el.nativeElement);
        this._keyboardNavigator.toggleNavigation = ($event) =>
            this.onToggleNavigationClick($event);
        this._keyboardNavigator.openDropdown = (id) => {
            this._ngbDropdowns.forEach((value) => {
                if (value.id === id) {
                    value.open();
                } else {
                    value.close();
                }
            });
        };
        this._keyboardNavigator.notificationBell = ($event) =>
            this.onNotificationBellClick($event);
    }

    ngOnInit(): void {
        this._routerEventsSub = this._router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            // eslint-disable-next-line no-return-assign
            .subscribe((event) => (this.isCollapsed = true));

        this.load(false)
            // eslint-disable-next-line n/handle-callback-err
            .subscribe(null, (error) => null);

        this.loadPhoto()
            // eslint-disable-next-line n/handle-callback-err
            .subscribe(null, (error) => null);
    }

    ngOnDestroy(): void {
        if (this._routerEventsSub) {
            this._routerEventsSub.unsubscribe();
        }
        if (this._notificationSub) {
            this._notificationSub.unsubscribe();
        }
        if (this._panelToggleSub) {
            this._panelToggleSub.unsubscribe();
        }

        this._navService.reset();
        this._navService.register(null);
    }

    load(forceReload: boolean): Observable<NavItem[]> {
        this.nav = [];
        this.navLoaded = false;
        this.navError = false;

        return this._navService.list(forceReload).pipe(
            map((nav: NavItem[]) => {
                this.nav = nav;
                this.navLoaded = true;
                return nav;
            }),
            catchError((error) => {
                console.log(error);
                this.navError = true;
                throw error;
            }),
        );
    }

    loadPhoto(): Observable<string> {
        this.photoUrl = null;

        return this._userService.retrievePhoto(this.user.id).pipe(
            map((dataUri) => {
                this.photoUrl =
                    this._domSanitizer.bypassSecurityTrustUrl(dataUri);
                return dataUri;
            }),
        );
    }

    onToggleNavigationClick($event: MouseEvent | KeyboardEvent): void {
        $event.preventDefault();
        this.isCollapsed = !this.isCollapsed;
    }

    onNotificationBellClick($event: MouseEvent | KeyboardEvent): void {
        $event.preventDefault();
        this.isCollapsed = true;
        this._notificationPanelService.toggleOpenState();
    }

    /**
     * @private
     *
     * workaround for routerLinkActive not picking up dynamic descendents. maybe a bit expensive
     */
    _childIsActive(item: NavItem): boolean {
        if (!item.isNested) {
            return item?.children?.some((e) => this._checkChildIsActive(e));
        } else {
            return item?.children?.some(
                (e) => e?.children?.some((ee) => this._checkChildIsActive(ee)),
            );
        }
    }

    private _checkChildIsActive(item: NavItem): boolean {
        return this._router.isActive(
            this._router.createUrlTree(
                Array.isArray(item?.link) ? item?.link : [item?.link],
                { queryParams: item?.queryParams },
            ),
            {
                paths: 'exact',
                queryParams: 'exact',
                fragment: 'ignored',
                matrixParams: 'ignored',
            },
        );
    }
}
